import { Card, Col, Row } from "antd";
import { DashboardHeader } from "features/dashboard/components/top-bar/Dashboard-header";
import { Fragment } from "react/jsx-runtime"
import { useLocation } from "react-router-dom";

export const RegistrationAnalysisstepPerMonthView = () => {
    const location = useLocation();
    const pathnameWithoutDashboard = location.pathname.replace('/dashboard/', '');

    return (
        <Fragment>
            <DashboardHeader title={pathnameWithoutDashboard} />
            <Row>
                <Col span={6}>
                    <div className="sales_regis">
                        <Card>
                            <img src="" alt="" />
                            <p>Total Participants - Registration</p>
                            <h2>KWD 140000</h2>
                        </Card>
                    </div>
                </Col>
            </Row>
            {/* <Row>
                <Col span={24}>
                    <RegistrationAnalysisstepPerMonth />
                </Col>
                <Col span={6}>
                    <RegistrationbookedtypeView />
                </Col>
                 <Col span={6}>
                    <RegistrationChannelView />
                </Col>
                   <Col span={6}>
                    <RegistrationAbandonmentView />
                </Col>
                <Col span={6}>
                    <RepeatParticipationView />
                </Col>
               
            </Row> */}
        </Fragment>
    )
}